export const SET_ITERATE_BY = 'REPORTING_SET_ITERATE_BY';

export const setIterateBy = iterateBy => ({
  type: SET_ITERATE_BY,
  iterateBy,
});
